import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { motion } from "framer-motion";

// Fix for missing marker icons
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const MapComponent = ({ location, name, district, state, pincode }) => {
  return (
    <motion.div
      className=" shadow-red-600 shadow-md"
      initial={{ x: 1000 }}
      animate={{ x: 0 }}
      transition={{ duration: 2, delay: 0.2 }}
    >
      <MapContainer
        className="rounded-xl  "
        center={location}
        zoom={9}
        style={{ height: "300px", width: "100%" }}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://reecocefe.in/copyright">reecocefe.in</a> contributors'
        />
        <Marker position={location}>
          <Popup>
            {name}, {district}, {state} ,{pincode}
          </Popup>
        </Marker>
      </MapContainer>
    </motion.div>
  );
};

export default MapComponent;
